import {
  CreateMemberRoundInput,
  CreateGuestRoundInput,
  NewGuestRoundInput,
} from "@/features/BookingWizard/hooks/useCreateNewRequestBooking/__generated__/useCreateNewRequestBookingMutation.graphql";

import { BookingWizard } from "../../types";
import { ClientType } from "./types";

export const processPrivateRequestRounds = <
  T extends CreateMemberRoundInput | CreateGuestRoundInput | NewGuestRoundInput
>(
  rounds: BookingWizard.RequestRound[] | undefined,
  clientTypes: ClientType[],
  courseLayoutId: string | null,
  additionalProps?: (round: BookingWizard.RequestRound) => Partial<T>,
  includeBookingIndex = true
): T[] => {
  const filteredRounds =
    rounds?.filter((round) => clientTypes.includes(round.player.clientType)) ??
    [];

  return filteredRounds.map((round): T => {
    const baseRound = {
      ...(round.id ? { id: round.id } : {}),
      index: round.index,
      ...(includeBookingIndex && round.bookingIndex !== undefined
        ? { bookingIndex: round.bookingIndex }
        : {}),
      playerId:
        round.player.clientType === "newGuest" ||
        round.player.clientType === "memberHold" ||
        round.player.clientType === "unknownGuest"
          ? undefined
          : round.player.id,
      nonPlayingHost:
        round.player.clientType === "member"
          ? round.player.nonPlayingHost
          : undefined,
      courseLayoutId: courseLayoutId ?? null,
      ...(additionalProps ? additionalProps(round) : {}),
    } as T;

    return baseRound;
  });
};
